// test2034
(2034 && 0);
